export const QUERY_STATUS = {
  PENDING: 1,
  EXECUTED: 2,
  ERROR: 3,
};

export const DMS = {
  UNKNOWN: 1,
  NTCAR: 2,
  EVA: 3,
  WINCAR: 4,
  ANON_EVA: 5,
  AUTOLINE: 6,
  AUTOLINE_EF_NEFKENS: 7,
  TEST_API: 8,
  TEST_SOW: 9,
  INCADEA: 10,
  TRUCK_VISION: 11,
  ICAR_WO: 12,
  CARIT: 13,
  AUTOLINE_OPEL_MENU: 14,
  KEYLOOP_MENUS: 15,
  CUSTOM_QUERIES: 16,
  KEYLOOP_JOBS: 17,
  EVA_BE_WO: 18,
  ICAR_PLANNING: 19,
  AUTOFLEX: 20,
  AUTOFLEX_QA_STAGING: 21,
  NEXTLANE: 22,
  WINCAR_V1_WB: 23,
  EVA_BE: 24,
  EVA_FR: 25,
  INCADEA_API: 26,
  WINCAR_V2_WB: 27,
  WINCAR_API_EVENTS: 29,
  WINCAR_API_V2_EVENTS: 30,
  KEYLOOP_MENUS_STAGING: 31,
  KEYLOOP_JOBS_STAGING: 32,
  CARIT_HYBRID: 33,
  INCADEA_HYBRID: 34,
  VINACLES: 35,
  TURBO_SAP: 36,
  GRAND_PRIX_PUBLIC_API: 37,
  CARSYS_PUBLIC_API: 38,
};

export const SEVERITY = {
  LOG: 1,
  WARNING: 2,
  ERROR: 3,
  CRITICAL: 4,
};

export const SOURCE = {
  CLIENT: 1,
  SERVER: 2,
  CUSTOM_QUERY: 3,
};

export const getDMSName = id => {
  switch (id) {
    case DMS.ANON_EVA:
      return "Anonymous Eva";
    case DMS.AUTOLINE_EF_NEFKENS:
      return "Autoline EF Nefkens";
    case DMS.AUTOLINE:
      return "Autoline";
    case DMS.EVA:
      return "EVA";
    case DMS.NTCAR:
      return "NTCar";
    case DMS.TEST_API:
      return "Test API";
    case DMS.TEST_SOW:
      return "Test SOW";
    case DMS.TRUCK_VISION:
      return "TruckVision";
    case DMS.ICAR_WO:
      return "ICar WO";
    case DMS.KEYLOOP_MENUS:
      return "Keyloop Menus";
    case DMS.CARIT:
      return "CarIT";
    case DMS.AUTOLINE_OPEL_MENU:
      return "Autoline Opel Menu";
    case DMS.CUSTOM_QUERIES:
      return "Custom Queries";
    case DMS.KEYLOOP_JOBS:
      return "Keyloop Jobs";
    case DMS.EVA_BE_WO:
      return "EVA Be Wo";
    case DMS.WINCAR:
      return "Wincar";
    case DMS.INCADEA:
      return "Incadea";
    case DMS.ICAR_PLANNING:
      return "ICAR Planning";
    case DMS.AUTOFLEX:
      return "Autoflex";
    case DMS.AUTOFLEX_QA_STAGING:
      return "Autoflex QA Staging";
    case DMS.NEXTLANE:
      return "Nextlane";
    case DMS.WINCAR_V1_WB:
      return "Wincar V1 WB";
    case DMS.EVA_BE:
      return "EVA Belgium";
    case DMS.EVA_FR:
      return "EVA French";
    case DMS.INCADEA_API:
      return "Incadea API";
    case DMS.WINCAR_V2_WB:
      return "Wincar V2 WB";
    case DMS.WINCAR_API_EVENTS:
      return "Wincar Api Events";
    case DMS.WINCAR_API_V2_EVENTS:
      return "Wincar Api V2 Events";
    case DMS.KEYLOOP_MENUS_STAGING:
      return "Keyloop Menus Staging";
    case DMS.KEYLOOP_JOBS_STAGING:
      return "Keyloop Jobs Staging";
    case DMS.CARIT_HYBRID:
      return "CarIT Hybrid";
    case DMS.INCADEA_HYBRID:
      return "Incadea Hybrid";
    case DMS.VINACLES:
      return "Vinacles";
    case DMS.TURBO_SAP:
      return "Turbo SAP";
    case DMS.GRAND_PRIX_PUBLIC_API:
      return "Grand Prix Public API";
    case DMS.CARSYS_PUBLIC_API:
      return "Carsys Public API";
    case DMS.UNKNOWN:
      return "Unknown";

    default:
      return "";
  }
};

export const parseDate = time => {
  if (!time) return null;
  if (time instanceof Date) return time;

  const timeValues = time.split(":");
  const date = new Date();
  date.setHours(timeValues[0] - 0, timeValues[1] - 0, timeValues[2] - 0);

  return date;
};

export const isKeyloopLocation = dmsId => [DMS.KEYLOOP_MENUS, DMS.KEYLOOP_JOBS, DMS.KEYLOOP_MENUS_STAGING, DMS.KEYLOOP_JOBS_STAGING].includes(dmsId);
